/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import { z } from 'zod';
const baseSchema = z.object({
    id: z.string(),
    identifier: z.string(),
    value: z.string(),
    expiresAt: z.coerce.date(),
    createdAt: z.coerce.date().default(() => new Date()),
    updatedAt: z.coerce.date(),
}
).strict();
const baseSchemaWithoutDefaults = z.object({
    id: z.string(),
    identifier: z.string(),
    value: z.string(),
    expiresAt: z.coerce.date(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
}
).strict();

/**
 * `Verification` schema excluding foreign keys and relations.
 */
export const VerificationScalarSchema = baseSchema;


/**
 * `Verification` schema including all fields (scalar, foreign key, and relations) and validations.
 */
export const VerificationSchema = VerificationScalarSchema;


/**
 * Schema used for validating Prisma create input. For internal use only.
 * @private
 */
export const VerificationPrismaCreateSchema = baseSchemaWithoutDefaults.partial().passthrough();


/**
 * Schema used for validating Prisma update input. For internal use only.
 * @private
 */
export const VerificationPrismaUpdateSchema = z.object({
    id: z.string(),
    identifier: z.string(),
    value: z.string(),
    expiresAt: z.coerce.date(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date()
}).partial().passthrough();


/**
 * `Verification` schema for create operations excluding foreign keys and relations.
 */
export const VerificationCreateScalarSchema = baseSchemaWithoutDefaults.partial({
    id: true, createdAt: true, updatedAt: true
});


/**
 * `Verification` schema for create operations including scalar fields, foreign key fields, and validations.
 */
export const VerificationCreateSchema = baseSchemaWithoutDefaults.partial({
    id: true, createdAt: true, updatedAt: true
});


/**
 * `Verification` schema for update operations excluding foreign keys and relations.
 */
export const VerificationUpdateScalarSchema = baseSchemaWithoutDefaults.partial();


/**
 * `Verification` schema for update operations including scalar fields, foreign key fields, and validations.
 */
export const VerificationUpdateSchema = VerificationUpdateScalarSchema;

